// Dependencies
import { useEffect, useState } from "react";

/**
 * This hook will return a debounced value. This is useful for when you want to
 * delay the execution of a function until the user has stopped typing.
 * @param value the value to debounce
 * @param delay how long to wait before executing the function
 * @returns
 */
const useDebouncedValue = (value: string, delay: number) => {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
};

export default useDebouncedValue;
